export default {
  'moduleTitle.address': 'Adresse',
  'moduleTitle.address_details': "Détails de l'adresse",
  'moduleTitle.activity_details': "Détails de l'activité ",
  'moduleTitle.add_log': 'Ajouter une entrée',
  'moduleTitle.award_level': 'Niveau du Prix',
  'moduleTitle.adventurous_journey': "Voyage d'aventure",
  'moduleTitle.already_assessed': 'Déjà évalué!',
  'moduleTitle.approved': 'Approuvé!',
  'moduleTitle.assessor_details': "Informations de l'évaluateur",
  'moduleTitle.authorising_contact_license_holder': 'Contact autorisé / Détenteur de licence',
  'moduleTitle.category_journey_details': '{catégorie} Détails du voyage',
  'moduleTitle.complete_report': 'Compléter le rapport',
  'moduleTitle.completed_progress': 'Terminé {terminé} / {total}',
  'moduleTitle.congratulation': 'Félicitations!',
  'moduleTitle.confirming_email_address': 'Confirmez votre courriel...',
  'moduleTitle.contact_details': 'Information du contact',
  'moduleTitle.edit_log': "Modifier l'entrée",
  'moduleTitle.event_journey': 'Voyage {event}',
  'moduleTitle.forgotten_password': 'Mot de passe oublié',
  'moduleTitle.great_you_are_almost_there': 'Super! Vous y êtes presque. Il ne reste plus qu’à procéder au paiement du nouveau prix.',
  'moduleTitle.home_address': 'Adresse de résidence',
  'moduleTitle.journey_overview': 'Sommaire du voyage',
  'moduleTitle.log_detail': "Détails de l'entrée",
  'moduleTitle.login': 'Connexion',
  'moduleTitle.new_activity': 'Nouvelle activité',
  'moduleTitle.new_event_journey': 'Nouveau voyage {event}',
  'moduleTitle.new_residential_project': 'Nouveau projet de résidence',
  'moduleTitle.notRegistred': 'Vous n’êtes pas encore inscrit?',
  'moduleTitle.nominated_award_leader_contact_details': 'Coordonnées du chef de groupe principal',
  'moduleTitle.nominated_award_leader': 'Chef de groupe principal',
  'moduleTitle.organisation_address': "Adresse de l'organisation",
  'moduleTitle.organisation_details': "Informations de l'organisation",
  'moduleTitle.online_record_book_account': 'Compte du carnet virtuel du participant',
  'moduleTitle.page_not_found': '404- Page introuvable',
  'moduleTitle.personal_details': 'Informations personnelles',
  'moduleTitle.preparation_and_training': 'Entraînement préparatoire',
  'moduleTitle.profile_guardian_consent': 'Consentement des parents / tuteurs',
  'moduleTitle.profile_questions': 'Questions de profil',
  'moduleTitle.registration_for_level': 'Adhésion pour le niveau',
  'moduleTitle.residential_project': 'Projet de résidence',
  'moduleTitle.residential_project_details': 'Détails du projet de résidence',
  'moduleTitle.reset_password': 'Réinitialiser le mot de passe',
  'moduleTitle.welcome_to_the_orb': 'Bienvenue au carnet virtuel du participant',
  'moduleTitle.we_have_sent_you_an_email': 'Nous vous avons envoyé un lien d’activation par courriel.',
  'moduleTitle.your_registration_is_complete': 'Votre inscription est terminée.',
  'formTitle.activity_details': "Détails de l'activité",
  'formTitle.assessor_details': "Informations de l'évaluateur",
  'formTitle.supervisors_details': 'Informations du superviseur',
  'formTitle.preparation_and_training_activities': "Activités de l'entraînement préparatoire",
  'formTitle.added_preparation_activities': "Activités de l'entraînement préparatoire ajoutées",
  'label.add_picture': 'Ajouter une photo',
  'label.address_first_line': 'Adresse (ligne 1)',
  'label.address_second_line': 'Adresse (ligne 2) (optionnel)',
  'label.are_you_already_running_award': 'Opérez-vous déjà le Prix?',
  'label.are_you_the_main_award_leader': 'Êtes-vous le chef de groupe principal ou le coordonnateur du Prix pour votre groupe?',
  'label.award_participant': 'Participant au Prix',
  'label.award_leader': 'Chef de groupe',
  'label.birthdate': 'Date de naissance',
  'label.category': 'Catégorie',
  'label.change_locale': "Changer d'endroit",
  'label.choose_project': 'Choisir un projet',
  'label.city': 'Ville',
  'label.choose_as_major_activity': 'Choisir comme concentration',
  'label.date': 'Date',
  'label.date_of_birth': 'Date de naissance',
  'label.description_of_progress': 'Description de votre progrès',
  'label.duration': 'Durée (min)',
  'label.email': 'Courriel',
  'label.email_address': 'Courriel ',
  'label.email_again': 'Entrez à nouveau votre courriel',
  'label.employment_status': "Situation d'emploi",
  'label.end_date': 'Date de fin',
  'label.enter_his_email': 'Entrez son courriel',
  'label.entered_transaction_id': 'Votre numéro de transaction',
  'label.first_name': 'Prénom',
  'label.gender': 'Sexe',
  'label.goal': 'Objectif',
  'label.journey_activity': 'Activité du voyage',
  'label.journey_objective': 'Objectif du voyage',
  'label.journey_observations': 'Observations du voyage',
  'label.journey_type': 'Type de voyage',
  'label.last_name': 'Nom de famille',
  'label.level': 'Niveau',
  'label.location': 'Endroit',
  'label.logout': 'Déconnexion',
  'label.major': 'Concentration',
  'label.middle_name': 'Autres prénoms',
  'label.mode_of_transport': 'Moyen de transport',
  'label.my_award_leader': 'Mon chef de groupe',
  'label.name': 'Nom',
  'label.nationality': 'Nationalité',
  'label.no': 'Non',
  'label.no_results': 'Aucun résultat',
  'label.note': 'Note',
  'label.note_for_assessor': "Commentaires pour l'évaluateur",
  'label.note_for_leader': 'Commentaires pour le chef de groupe',
  'label.optional': 'optionnel',
  'label.organisation_name': "Nom de l'organisation",
  'label.organisation_type': "Type d'organisation",
  'label.others': 'Autres',
  'label.password': 'Mot de passe',
  'label.password_again': 'Répéter le mot de passe',
  'label.project_location': 'Endroit du projet',
  'label.pay_online': 'Paiement en ligne',
  'label.pay_award_leader_or_unit': 'Paiement au chef de groupe ou au groupe',
  'label.payment_not_required': 'Paiement non requis',
  'label.payment_type': 'Type de paiement',
  'label.phone': 'Téléphone',
  'label.phone_number': 'Numéro de téléphone',
  'label.phone_type': 'Type de numéro de téléphone',
  'label.profile': 'Profil',
  'label.reset_password': 'Réinitialiser le mot de passe',
  'label.region': 'État/Province/Région',
  'label.relationship': 'Lien',
  'label.role_in_organisation': "Rôle dans l'organisation",
  'label.select_country': 'Sélectionnez un pays',
  'label.select_your_au': 'Sélectionnez un groupe',
  'label.start_typing': 'Commencez à taper',
  'label.start_date': 'Date de début',
  'label.select': 'Sélectionnez',
  'label.select_async': 'Commencez à taper',
  'label.select_your_operating_authority': 'Sélectionnez votre opérateur du Prix',
  'label.specify_category': 'Veuillez choisir une catégorie',
  'label.subcategory': 'Sous-catégorie',
  'label.title': 'Titre',
  'label.username': "Nom d'utilisateur",
  'label.what_is_your_role': 'Quel est votre rôle dans votre organisation?',
  'label.where_have_you_completed': "Où l'avez-vous complété?",
  'label.yes': 'Oui',
  'label.your_changes_havent_been_saved': "Vos changements n'ont pas été enregistrés. Les données seront perdues",
  'label.zip': 'Code postal',
  'label.adventurous_journey': "Voyage d'aventure",
  'label.after_your_journey_describe': 'Notez vos observations sur votre voyage d’aventure en quelques phrases.',
  'label.because_your_age_is_under_18': 'Comme vous avez moins de 18 ans, nous avons besoin du consentement d’un parent ou tuteur légal.',
  'label.before_you_head_to_journey': "Avant d’entreprendre votre voyage de qualification, vous devez terminer l'entraînement préparatoire.",
  'label.before_entering_new_level': 'Avant de commencer votre prochain prix, vérifiez que vos renseignements personnels sont à jour.',
  'label.bring_required_amount_to_your_award_leader': 'Remettez le montant requis à votre chef de groupe ou au coordonnateur du Prix de votre groupe.',
  'label.do_you_have_any_other_level': 'Avez-vous déjà complété un niveau du Prix?',
  'label.do_you_know_who_is_your_award_leader': 'Connaissez-vous votre chef de groupe?',
  'label.going_on_an_expedition': 'Partir en expédition est l’occasion de vivre une aventure, de travailler en équipe et de faire preuve d’initiative.',
  'label.going_on_residential_gives_chance': 'Le projet de résidence est l’occasion d’apprendre à travailler avec des gens de différents horizons et de s’acclimater à de nouveaux milieux. ',
  'label.i_confirm_that_i_meet': 'Je confirme que je satisfais toutes les exigences réglementaires de l’entité responsable du Prix.',
  'label.i_agree_to_volunteer_code': 'J’accepte le code de conduite des bénévoles. Pour en savoir plus, cliquez ici.',
  'label.i_have_read_the_terms_and_conditions': 'J’accepte le code de conduite des bénévoles. Pour en savoir plus, cliquez ici.',
  'label.i_will_bring_the_consent_to_my_award_leader_later': 'Je remettrai le consentement à mon chef de groupe plus tard.',
  'label.if_you_are_from_orphanage': 'Si votre école ou organisation jeunesse couvre les frais pour vous, par exemple.',
  'label.here_you_can_add_activity': "Vous pouvez ajouter ici une nouvelle activité à l'entraînement préparatoire.",
  'label.how_do_you_want_to_apply': 'Comment souhaitez-vous poser votre candidature?',
  'label.my_parent_consent_has_been_already_given': 'Mon parent ou tuteur légal a déjà donné son consentement à mon chef de groupe.',
  'label.my_parent_will_confirm_consent_by_email': 'Mon parent ou tuteur légal confirmera son consentement par courriel.',
  'label.major_activity_means_that_you_have_to_spent': 'Une concentration est une activité à laquelle vous devez consacrer deux fois plus de temps qu’aux autres.',
  'label.not_sure_about_your_auth': 'Communiquez avec nous pour connaître l’entité responsable du Prix dans votre région.',
  'label.page_not_found': '404 - Page introuvable',
  'label.please_fill_in_the_following': 'Veuillez remplir les champs suivants pour l’autorisateur ou le détenteur de permis de votre organisation.',
  'label.register_a_new_account_as': 'Créer un nouveau compte en tant que :',
  'label.residential_project': 'Projet de résidence',
  'label.select_your_award_unit': 'Sélectionnez un groupe',
  'label.the_expedition_can_be_faraway': 'L’expédition peut avoir lieu près ou loin de votre domicile et prendre une multitude de formes.',
  'label.to_log_your_process_on_orb': 'Pour consigner votre progression dans le Carnet virtuel du participant, vous devez ouvrir un compte. <br />Entrez vos renseignements ici.',
  'label.waiting_for_assessment': "En attente de l'évaluation",
  'label.waiting_for_sign_off': 'En attente de la validation du chef de groupe',
  'label.we_have_sent_you_an_email': 'Nous vous avons envoyé un lien d’activation par courriel.',
  'label.what_level_of_the_award': 'Quel niveau du Prix voulez-vous adhérer?',
  'label.you_are_now_registering_as_participant': 'Vous êtes en train de faire votre inscription en tant que participant.',
  'label.you_are_now_registering_as_award_unit': 'Vous êtes en train de faire votre inscription en tant que groupe.',
  'label.you_can_use_my_photos_for_promotional_purposes': 'En tant que participant au programme du Prix du Duc d’Édimbourg, j’autorise la Fondation à utiliser mes images à des fins promotionnelles.',
  'label.you_can_send_activity_for_approval': 'Vous pouvez soumettre votre activité à votre évaluateur pour approbation',
  'label.you_can_send_activity_for_leader': 'Vous pouvez soumettre votre activité à votre chef de groupe pour approbation',
  'label.you_can_send_residential_project_to_leader': 'Vous pouvez soumettre votre projet de résidence à votre chef de groupe pour approbation',
  'label.you_have_finished_now_send_to_approval': 'Votre activité est terminée. Vous pouvez la soumettre à votre évaluateur pour évaluation. Vous pouvez y ajouter un commentaire:',
  'label.preparation_and_training': 'Entraînement préparatoire',
  'label.you_will_be_redirected_to_the_payment': 'Vous serez redirigé vers la passerelle de paiement, où vous pouvez payer par carte de crédit ou de débit.',
  'label.you_will_be_the_first_award_leader': 'Vous serez le premier chef de groupe de votre organisation. Vous aurez les droits nécessaires pour nommer de nouveaux chefs de groupe, ajouter des participants et superviser le cheminement du programme dans le Carnet virtuel du participant.',
  'label.youll_receive_a_notification': 'Vous recevrez une notification quand votre chef de groupe aura approuvé votre inscription. Cliquez ici pour ouvrir une session dans le Carnet virtuel du participant nouvelle génération (vous n’aurez pas accès à certaines fonctionnalités avant que votre chef de groupe approuve votre inscription).',
  'label.your_parent_email': 'Courriel de votre parent / tuteur',
  'label.your_parent_first_name': 'Prénom de votre parent / tuteur',
  'label.your_parent_last_name': 'Nom de famille de votre parent / tuteur',
  'label.your_report_approve_now_send_to_leader': 'Votre évaluateur a approuvé votre rapport. Vous pouvez le soumettre à votre chef de groupe pour approbation. Vous pouvez y ajouter des commentaires.',
  'label.there_are_loads_of_exciting_possibilities': 'Il y a des tonnes de possibilités et d’occasions palpitantes. Choisissez une activité qui sera source d’épanouissement.',
  'label.your_residential_project_has_been_setup': 'Votre projet de résidence a été créé et soumis à l’approbation du chef de groupe.',
  'label.your_report_has_been_sent_assessor': 'Votre rapport a été soumis à votre évaluateur pour approbation',
  'label.your_report_has_been_sent_leader': 'Votre rapport a été soumis à votre chef de groupe pour approbation',
  'label.your_residential_project_is_complete': 'Votre projet de résidence est terminé.',
  'label.to_work_on_the_online': 'Pour utiliser le Carnet virtuel du participant, vous devez ouvrir un compte.',
  'label.we_will_send_you_an_email': 'Nous vous enverrons un courriel quand votre inscription au Carnet virtuel du participant sera approuvée.',
  'label.if_you_have_any_problems_or_doubts': 'En cas de problème ou de doute, communiquez avec votre groupe.',
  'label.are_you_sure_you_want_to_leave': 'Êtes-vous sûr de vouloir quitter? Vos données seront perdues.',
  'label.no_logs_yet': 'Aucune entrée pour le moment.<br /> Créez votre première entrée en cliquant sur le bouton « Ajouter une entrée ».',
  'label.menu': 'Menu',
  'notifications.award_unit_has_been_created': 'Votre groupe a été créé',
  'notifications.authorization_code_is_not_valid': 'Le code d’autorisation est expiré.',
  'notifications.email_has_been_confirmed': 'L’adresse courriel a été confirmée.',
  'notifications.leader_has_been_created': 'Le chef de groupe a été créé.',
  'notifications.participant_has_been_created': 'Le participant a été créé',
  'notifications.email_with_instructions_has_been_sent': 'Un courriel contenant les instructions vous a été envoyé',
  'notifications.your_new_password_has_been_set': 'Votre nouveau mot de passe est enregistré',
  'notifications.success': 'Succès',
  'notifications.unknown_role': 'Rôle inconnu',
  'notifications.waiting_for_approval': "En attente de l'approbation",
  'notifications.activity_cannot_be_created': 'L’activité ne peut être créée tant que votre inscription n’a pas été approuvée.',
  'notifications.new_activity_has_been_added': 'Une nouvelle activité a été ajoutée',
  'notifications.new_log_has_been_added': 'Une nouvelle entrée a été ajoutée',
  'notifications.log_has_been_deleted': "L'entrée a été supprimée",
  'notifications.log_has_been_modified': "L'entrée",
  'notifications.adventurous_journey_cannot_be_created_until_approved': 'Le voyage d’aventure ne peut être créé tant que votre inscription n’a pas été approuvée.',
  'notifications.new_participant_event_has_been_added': 'Un nouvel évènement du participant a été ajouté',
  'notifications.participant_event_has_been_completed': "L'évènement du participant est terminé",
  'notifications.training_and_practice_modified': "L'entraînement préparatoire a été modifié",
  'notifications.completion_residential_project_completed': 'Le projet de résidence est terminé',
  'notifications.new_residential_project_has_been_added': 'Un nouveau projet de résidence a été ajouté',
  'notifications.residential_project_cannot_be_created_until_approved': 'Le projet de résidence ne peut être créé tant que votre inscription n’a pas été approuvée.',
  'notifications.already_assessed_sent': 'La demande d’approbation du chef de groupe a été envoyée.',
  'notifications.assessment_request_sent': "La demande d'évaluation a été envoyée",
  'notifications.leader_approval_sent': 'La demande de chef de groupe a été envoyée',
  'tabs.logs': 'Entrée',
  'tabs.new': 'Nouveau',
  'tabs.overview': 'Sommaire',
  'tabs.report': 'Rapport',
  'button.add_activity': 'Ajouter une activité',
  'button.add_log': 'Ajouter une entrée',
  'button.continue_here': 'Continuez ici',
  'button.continue': 'Continuer',
  'button.continue_to_award': 'Continuer le Prix',
  'button.delete': 'Supprimer',
  'button.edit': 'Modifier',
  'button.edit_log': "Modifier l'entrée",
  'button.finish': 'Terminer',
  'button.forgot_your_password': 'Mot de passe oublié?',
  'button.i_already_have_assessment': 'J’ai déjà eu mon évaluation.',
  'button.leave_anyway': 'Quitter quand même.',
  'button.login': 'Connexion',
  'button.no': 'Non',
  'button.register': 'Adhérer',
  'button.send': 'Envoyer',
  'button.send_for_approval': 'Envoyer pour approbation',
  'button.setup': 'Configuration',
  'button.setup_residential': 'Créer un projet de résidence',
  'button.stay': 'Rester',
  'button.submit': 'Soumettre',
  'button.update': 'Mettre à jour',
  'button.yes': 'Oui',
  'errors.at_least_num_characters': 'Doit contenir au minimum {length} caractères',
  'errors.do_not_match': 'Ne correspond pas',
  'errors.include_at_least_one_number': 'Doit contenir au minimum un chiffre',
  'errors.include_both_lower_and_upper_case': 'Doit inclure au moins une majuscule et une minuscule',
  'errors.invalid_phone_format': 'Format du numéro de téléphone invalide',
  'errors.invalid_email_address': 'Courriel invalide',
  'errors.required_field': 'Champs obligatoire',
  'errors.must_be_at_least': 'Doit contenir au minimum {min} caractères',
  'errors.must_be_no_more_than': 'Doit contenir un maximum de {max} caractères',
  'errors.must_be_an_integer': 'Doit être un nombre entier',
  'errors.must_contain_at_least': 'Doit contenir au minimum un chiffre',
  'errors.must_include_at_least': 'Doit contenir au minimum une majuscule',
  'errors.must_be_one_of': 'Doit figurer parmi les suivants : {enums}',
  'errors.you_must_be_younger_than': 'Vous devez avoir moins de {years} ans et {months} mois pour vous inscrire au Prix. Communiquez avec le personnel de votre groupe.',
  'errors.you_must_be_older_than': 'Vous devez avoir plus de {years} ans et {months} mois pour vous inscrire au Prix. Communiquez avec le personnel de votre groupe.',
  'errors.email_address_is_in_use_please_sign': 'Adresse courriel déjà utilisée. Pour vous inscrire à un autre prix, ouvrez une session avec votre compte.',
  'errors.email_address_is_in_use': 'Adresse courriel déjà utilisée.',
  'errors.sorry_we_already_have_this_email': 'Désolé. Cette adresse courriel est liée à un autre compte. Pour commencer un nouveau prix, ouvrez une session et sélectionnez l’option Commencer un nouveau prix.',
  'wizard.authorising_contact': 'Contact autorisé',
  'wizard.award_leader_contact': 'Coordonnées du chef de groupe',
  'wizard.award_unit_details': 'Informations sur le groupe',
  'wizard.contact_details': 'Informations sur le contact',
  'wizard.contacts': 'Contacts',
  'wizard.level': 'Niveau du Prix',
  'wizard.level_selection': 'Sélectionner un Prix',
  'wizard.leader_details': 'Informations sur chef de groupe',
  'wizard.nominated_award_leader': 'Chef de groupe principal',
  'wizard.orb_account': 'Compte CVP',
  'wizard.parent_consent': 'Consentement des parents',
  'wizard.participant_details': 'Informations du participant',
  'wizard.profile': 'Profil',
  'wizard.payment': 'Paiement',
  'wizard.select_award_unit': 'Sélectionner un groupe',
  'wizard.unit_details': 'Informations du groupe',
  'wizard.welcome': 'Bienvenue',
  'wizard.your_details': 'Vos informations',
  'awardUnit.do_you_want_to_create': 'Voulez-vous créer un nouveau groupe?',
  'parent.you_can_download_the_consent_here': 'Vous pouvez télécharger le formulaire de consentement parental ici si vous ne l’avez pas déjà. Faites-le signer par votre parent ou tuteur légal, puis remettez-le à votre chef de groupe.',
  'footer.copyright': 'Le Prix international du Duc d’Édimbourg 2017. Tous droits réservés.',
  'registration_participant.required_award_payment': 'Paiement du prix exigé',
  'registration_participant.pay_online_here': 'Payez et obtenez votre numéro d’identification de transaction ici.',
  'dashboard.activity_log_time': '{hours}h {minutes}min',
  'moduleTitle.award_completed': 'Prix complété!',
  'notifications.award_approval_request_sent_to_leader': 'La demande d’approbation de prix a été envoyée à votre chef de groupe.',
  'notifications.new_participant_event_has_been_completed': 'Un nouvel évènement du participant a été terminé',
  'notifications.preparation_and_training_approval_sent': 'Entraînement préparatoire approuvé',
  'notifications.reparation_and_training_completed': 'Entraînement préparatoire complété',
  'notifications.your_profile_photo_has_been_edited': 'Votre photo de profil a été modifiée',
  'notifications.your_profile_has_been_edited': 'Votre profil a été modifié',
  'notifications.new_level_has_started': 'Le prochain niveau est débuté',
  'notifications.activity_has_been_edited': "L'activité a été modifiée",
  'notifications.you_have_been_logged_out': 'Déconnexion ...',
  'notifications.logging_out': 'Vous êtes déconnectés',
  'label.you_can_send_award_to_leader': 'Vous pouvez soumettre vos Prix pour approbation',
  'label.you_have_completed_all_sections_of_your_award': 'Vous avez complété tous les sections du Prix. Vous pouvez le soumettre à votre chef de groupe pour approbation. Vous pouvez y ajouter des commentaires.',
  'label.you_have_now_completed_your_award': 'Vous avez terminé votre prix {level}. Souhaitez-vous en commencer un autre?',
  'label.congratulation_your_award_has_been_approved': 'Félicitations! Votre prix {level} a été approuvé. <br />Si vous le souhaitez, vous pouvez commencer un nouveau prix.',
  'moduleTitle.settings': 'Réglages',
  'moduleTitle.edit_activity': 'Modifier une activité',
  'moduleTitle.select_your_major_activity': 'Sélectionnez votre concentration',
  'label.settings': 'Réglages',
  'label.major_activity_means_that_you_will': 'Une concentration est une activité à laquelle vous devrez consacrer plus de temps qu’aux autres. Pour les prix Or et Argent, vous devrez y consacrer six mois de plus; pour le prix Bronze, ce sont trois mois supplémentaires. ',
  'label.notifications': 'Alertes',
  'label.my_award': 'Mon Prix',
  'label.physical_recreation': 'Conditionnement physique',
  'label.skill': 'Habiletés',
  'label.service': 'Service à la collectivité',
  'label.my_parent_will_complete_and_sign_form': 'Mon parent ou tuteur légal remplira et signera le formulaire de consentement du parent ou tuteur légal.',
  'label.please_print_it_tak_it_to_your_parent': 'Imprimez ce document, faites-le signer par votre parent ou tuteur légal, puis remettez-le à votre chef de groupe.',
  'label.change_password': 'Modifier le mot de passe',
  'label.change_major_activity': 'Modifier la concentration',
  'title.change_password': 'Modifier le mot de passe',
  'label.old_again': 'Ancien mot de passe',
  'label.new_password': 'Nouveau mot de passe',
  'label.new_password_again': 'Entrez à nouveau le mot de passe',
  'errors.passwords_dont_match': 'Les mots de passe ne correspondent pas',
  'errors.more_than': 'Plus de {limite}',
  'button.parent_guardian_consent_pdf': 'Consentement des parents.pdf',
  'button.send_award_for_approval': 'Soumettre le Prix pour approbation',
  'button.send_report': 'Soumettre le rapport',
  'button.terms_and_conditions': 'Conditions internationales',
  'button.privacy_policy': 'Politique de confidentialité',
  'button.save': 'Sauvegarder',
  'button.start_new_level': 'Débuter un nouveau niveau',
  'button.change_password': 'Modifier le mot de passe',
  'button.edit_activity': "Modifier l'activité",
  'moduleTitle.file_upload': 'Téléverser un document',
  'label.add_file': 'Ajouter un document',
  'label.description': 'Description',
  'label.waiting_for_office_sign_off': "En attente de l'approbation du bureau",
  'notifications.file_has_been_uploaded': 'Les fichiers ont été téléversés',
  'tabs.files': 'Fichiers',
  'button.upload': 'Téléverser',
  'button.upload_file': 'Téléverser un fichier',
  'button.add_file': 'Ajouter un fichier',
  'button.this_activity_has_no_assessor': "Cette activité n'a pas d'évaluateur. Veuillez indiquer les informations de celui-ci afin de soumettre votre rapport pour approbation.",
  'label.i_want_to_register_my_award': 'Je voudrais inscrire mon groupe comme centre public du Prix.',
  'label.select_sub_operating_authority': "Sélectionner une sous-entité d'opération.",
  'label.your_must_first_setup_some_activity': 'Vous devez configurer votre activité en premier',
  'label.you_cant_change_your_major_activity': 'Vous ne pouvez pas modifier votre concentration. Votre concentration est déjà terminée.',
  'label.s_specific': 'Spécifique : votre objectif ne doit pas être trop vague. Au lieu de dire « je veux m’améliorer au violon », vous pourriez dire « je veux maîtriser la gamme de fa au violon ».',
  'label.m_measurable': 'Mesurable : vous devez être capable de déterminer à quel moment votre objectif est atteint. Au lieu d’avoir pour objectif « je veux aider la collectivité », vous pourriez dire « je veux aider les gens qui fréquentent les soupes populaires en y faisant du bénévolat une fois par semaine ». Il sera ainsi possible de dire si vous avez atteint votre objectif ou non.',
  'label.a_achievable': 'Atteignable : vous devez pouvoir atteindre votre objectif dans les délais alloués pour votre prix. À la place de dire « je veux éradiquer la pauvreté », vous feriez mieux de choisir un objectif pratique comme « je veux amasser des fonds pour combattre la pauvreté dans un village du tiers-monde. »',
  'label.r_realistic': 'Réaliste : si votre objectif est atteignable, il est aussi réaliste. Demandez-vous si vous serez capable d’atteindre vos buts dans les délais fixés.',
  'label.t_timely': 'Temporel : votre objectif doit être assorti d’une date butoir. Par exemple, « je veux maîtriser la clé de fa au violon d’ici trois mois ».',
  'label.you_can_upload_here_any_files': 'Vous pouvez téléverser tous les fichiers (10 mo maximum) que vous voulez partager avec votre chef de groupe.',
  'moduleTitle.login_change': "Nom d'utilisateur modifié.",
  'notifications.adventurous_journey_modified': "Votre voyage d'aventure a été modifié",
  'tabs.sections': 'Volets',
  'label.change_email': 'Modifier le courriel',
  'title.change_email': 'Modifier le courriel',
  'label.new_email': 'Nouveau courriel',
  'label.new_email_again': 'Entrez votre nouveau courriel à nouveau',
  'errors.emails_dont_match': 'Les courriels ne correspondent pas',
  'button.change_email': 'Modifier le courriel',
  'notifications.email_with_instructions_has_been_sent_to_your_inbox': 'Un courriel contenant les instructions vous a été envoyé.',
  'global.dofe_name': "Prix international du Duc d'Édimbourg",
  'global.or': 'ou',
  'route.landing_page': "Page d'acceuil",
  'route.dashboard': 'Tableau de bord',
  'moduleTitle.notifications': 'Alertes',
  'moduleTitle.no_notifications': 'Aucunes alertes',
  'moduleTitle.new_notifications': 'Nouvelles alertes',
  'moduleTitle.older_notifications': 'Alertes anciennes',
  'moduleTitle.user_guide': "Guide d'utilisateur",
  'label.user_guide': "Guide d'utilisateur",
  'notifications.your_password_has_been_changed': 'Votre mot de passe a été modifié',
  'label.country': 'Pays',
  'label.on_your_smartphone': 'Sur votre téléphone intelligent',
  'label.on_the_web': 'Sur le Web',
  'label.orb_online': 'CVP en ligne',
  'label.language': 'Langue',
  'moduleTitle.participant_login': "Nom d'utilisateur du participant",
  'label.for_ios': 'Pour IOS',
  'label.for_android': 'Pour Androïde',
  'button.login_as_award_staff': 'Connexion du personnel',
  'errors.leader_doesnt_exist': 'Chef de groupe inexistant',
  'global.loading': 'Chargement',
  'moduleTitle.award_staff_login': 'Connexion du personnel',
  'formTitle.residential_project_details': 'Détails du projet de résidence ',
  'label.you_can_also_download_participant': 'Vous pouvez télécharger notre nouvelle application pour les participants </strong> et accéder à votre Carnet Virtuel en tout temps.',
  'label.you_can_also_download_leader': 'Vous pouvez télécharger notre nouvelle application pour les chefs de groupe </strong> et accéder à votre Carnet Virtuel en tout temps.',
  'notifications.this_role_is_not': "Ce rôle n'est pas accepté pour le moment",
  'notifications.residential_project_has_been_updated': 'Le projet de résidence a été mis à jour',
  'tabs.participant': 'Participant',
  'tabs.award_staff': 'Personnel',
  'moduleTitle.edit_residential_project': 'Modifier le projet de résidence',
  'button.residential_project': 'Modifier le projet de résidence',
  'notifications.your_login_email_has_been_changed': 'Votre courriel a été modifier',
  'meta.dofe_name': "Le Prix du Duc d'Édimbourg",
  'notifications.unknown_role_leader': 'Rôle inconnu - Utiliser la connexion du personnel',
  'notifications.unknown_role_participant': 'Rôle inconnu - Utiliser la connexion du participant',
  'label.user_guide_web_participant': "Guide d'utilisateur Web - Participant",
  'label.user_guide_app_participant': "Guide d'utilisateur pour l'application - Participant",
  'label.note_for_supervisor': 'Commentaires pour le superviseur',
  'label.before_submitting_your_aj': "Avant de soumettre votre voyage à votre chef de groupe. vous devez obtenir l'approbation de votre {role}. Vous pouvez ajouter un commentaire.",
  'button.back_to_home': "Retour à la page d'accueil",
  'moduleTitle.assessor_approval': 'Approbation de {role}',
  'label.this_aj_has_no_assessor': "Votre voyage d'aventure n'a pas de {role}. Veuillez mettre à jours ces informations avant de le soumettre pour approbation.",
  'route.not_found': 'Non trouvé',
  'notifications.are_you_sure': 'Êtes-vous sûr?',
  'button.cancel': 'Annuler',
  'label.add_document': 'Ajouter un fichier',
  'errors.there_are_currently_no_details_for_your': "Il n'y aucunes informations concernant votre {role}. Veuillez indiquer ces informations avant de soumettre votre activité pour approbation.",
  'moduleTitle.missing_data': 'Informations manquantes',
  'label.to_send_assessment_request': 'Si vous désirez soumettre votre évaluation par voie électronique, veuillez indiquer le courriel de votre {role}.',
  'label.pending_changes': 'Changements en attente ...',
  'label.some_fields_require': 'Certains champs requièrent votre attention',
  'roles.assessor': 'Évaluateur',
  'roles.supervisor': 'Superviseur',
  'pageTitle.register_participant': 'Participants inscrits',
  'moduleTitle.revise_message': 'Message révisé',
  'moduleTitle.payment_for_level': 'Paiement pour {awardLevel}',
  'moduleTitle.payment': "Paiement des frais d'adhésion",
  'moduleTitle.we_have_sent_you_payment_link': 'Nous vous avons envoyé un courriel contenant le lien vers notre passerelle de paiement.',
  'label.required_award_payment': "Paiement des frais d'adhésion requis",
  'label.payment_fees': 'Frais de paiement',
  'label.payment_method': 'Méthode de paiement',
  'label.you_will_type_trans_id': 'Nous vous demanderons votre numéro de transaction',
  'label.any_level_previously': 'Avez-vous un complété un autre niveau du Prix auparavant?',
  'label.registering_for_level': 'Adhésion au prochain niveau',
  'notification.payment_link_expired': 'Le lien de paiement est expiré',
  'button.pay': 'Payer',
  'label.registration_updated': 'Cette adhésion a été mise à jour',
  'label.award_leader_receive_payment': "Le chef de groupe recevra l'information du paiement",
  'errors.end_date_after': 'La date de fin doit être après la date de début',
  'button.back': 'Retour',
  'button.edit_info': 'Modifier les informations',
  'moduleTitle.level_detail': 'Information sur le niveau',
  'label.payment_methods': 'Méthodes de paiement',
  'label.address': 'Adresse',
  'note.review_filled_participant': 'Veuillez réviser les informations fournies par le participant. Si les informations sont erronées, vous pouvez les modifier.',
  'moduleTitle.payment_successful': 'Le paiement a été effectué avec succès.',
  'button.proceed_to_login': 'Connectez-vous',
  'label.add_additional_activity': 'Ajouter une activité supplémentaire',
  'moduleTitle.welcome_to_orb': 'Bienvenue au carnet virtuel du participant',
  'empty_dashboard.not_approved': "Cet outil vous aidera dans le suivi de vos progrès au Prix. Votre chef de groupe n'a pas encore approuvé votre adhésion. Vous devez attendre son approbation avant de créer votre première activité.",
  'empty_dashboard.approved_1': 'Cet outil vous aidera dans le suivi de vos progrès au Prix.',
  'empty_dashboard.approved_2': "Premièrement, vous devez créer une activité. Pour débuter, cliquez sur une des activités à gauche. Si vous avez besoin d'aide pour créer une activité, demandez à votre chef de groupe.",
  'label.discuss_activity_leader': "Vous vous choisissez plus d'une activité pour un volet, veuillez en discuter avec votre chef de groupe.",
  'label.cannot_add_activity': 'Vous pouvez choisir un maximum de 3 activités pour ce volet. Veuillez en discuter avec votre chef de groupe.',
  'button.ok': 'Ok',
  'label.payment_was_canceled': "L'utilisateur a annulé le paiement.",
  'label.problem_with_payment': 'Il y a eu un problème lors du paiement. Veuillez communiquer avec votre entité national responsable du Prix.',
  'pageTitle.register_leader': 'Chef de groupe inscrit',
  'pageTitle.registration_complete': 'Adhésion complétée',
  'label.payment_link_expired_or_paid': 'Vous avez déjà effectuer votre paiement ou le lien est expiré',
  'label.contact_nao_assistance': "Contactez votre entité national responsable du Prix pour obtenir de l'aide",
  'label.send_required_amount_to_your_award_leader': 'Remettez le paiement à votre chef de groupe ou à votre coordonnateur du Prix',
  'label.fee_can_be_paid': "Les frais d'adhésion peuvent être acquittés en ligne par Visa, MasterCard ou Intérac",
  'notifications.login_failed_right_tab': "La connexion a échoué. Assurez-vous d'être dans le bon onglet (Participant / Employé du Prix)",
  'label.i_have_read_privacy_policy': "J'ai lu et j'accepte la politique sur la vie privée.",
  'errors.invalid_date_format': 'Le format de date est invalide.',
  'label.no_privacy_policy': 'Aucune politique sur la vie privée a été trouvé. Vous pouvez cliquer sur le button terminé en toute sécurité.',
  'label.status': 'Status',
  'moduleTitle.attached_with_observation': 'Joindre aux observations',
  'moduleTitle.revise_message_rp': 'Votre projet de résidence a été révisé par votre chef de groupe.',
  'file.activity_section_summary': 'Volet {section} - sommaire',
  'label.download_section_summary': 'Télécharger le sommaire du volet',
  'label.award_summary': 'Sommaire du Prix',
  'btn.download_summary_for_assessor': "Télécharger le sommaire pour l'évaluateur",
  'label.first_activity_started': 'Première activité débutée le',
  'label.hours_completed_required': 'heures complétées / requises',
  'label.weeks_completed_required': 'semaines complétées / requises',
  back_to_home: "Retourner à la page d'acceuil",
  'label.activity_rejected_click': 'Votre activité a été rejetée par votre chef de groupe. Cliquez ici pour',
  'button.more_information': "plus d'informations",
  'label.attached_file': 'Fichier joint.',
  'moduleTitle.journey_details': 'Détails du voyage',
  'tabs.activity': 'Activité',
  'label.confirm_email': 'Confirmer le courriel',
  'label.aj_rejected_click': 'Votre chef de groupe a refusé votre voyage. Cliquez ici pour',
  'label.verifying_payment': 'Vérifier le paiement',
  'button.finish_and_pay': 'Terminer et payer',
  'label.payment_not_successful_text': "Puisque vous n'avez pas complété le paiement pour le Prix du Duc, vous devez l'effectuer maintenant",
  'label.payment_not_completed': 'Paiement incomplet',
  'button.pay_now': 'Payer maintenant',
  'label.registration_pending_parental_consent': "Votre adhésion est en attente puisque nous n'avons pas reçu le consentement parental",
  'button.edit_observation': 'Modifier les observations',
  'moduleTitle.qualifying': 'de qualification',
  'moduleTitle.practice': 'pratique',
  'label.first_log_entry': 'Première entrée',
  'label.first_log_entry_date': 'Date de la première entrée',
  'label.last_log_entry': 'Dernière entrée',
  'label.last_log_entry_date': 'Date de la dernière entrée',
  'label.you_can_send_journey_report_for_approval': 'Vous pouvez soumettre votre rapport du voyage {journey} pour approbation',
  'button.edit_and_resend_report': 'Modifier et renvoyer le rapport',
  'label.your_journey_is_complete': 'Votre voyage {journeyType} est complété',
  'button.add_additional_journey': 'Ajouter un voyage supplémentaire',
  'moduleTitle.edit_journey': 'Modifier le voyage',
  'notifications.assessment_sent': "L'évaluation a été envoyée",
  'notifications.file_is_too_big': "Le fichier n'a pu être téléverser puisqu'il dépasse la taille maximale de 10 mo.",
  'notifications.authorization_code_has_expired': "Le code d'autorisation est expiré",
  'route.confirm_email': 'Confirmer le courriel',
  'label.assessor_needs_account': "Pour travailler sur le carnet virtuel du participant (CVP), vous avez besoin d'un compte personnel. <br/>Entrez vos détails ici.",
  'label.company_name': 'Nom de la compagnie',
  'label.secondary_email_again': 'Confirmer le courriel secondaire',
  'label.how_many_years': "Combien d'années/mois?",
  'label.no_company_leave_empty': 'Si vous ne travaillez pas pour une entreprise, veuillez laisser ce champ vide.',
  'label.secondary_phone_number': 'Numéro de téléphone secondaire',
  'label.secondary_phone_type': 'Type de téléphone secondaire',
  'label.wwc_application_number': '',
  'label.wwc_expiration_date': '',
  'label.you_are_now_registering_as_assessor': 'Vous êtes entrain de vous inscrire comme évaluateur',
  'label.you_have_finished_aj_now_send_to_approval': "Votre voyage d'aventure est terminé. Vous pouvez le soumettre à votre évaluateur pour approbation. Vous pouvez y ajouter un commentaire ci-dessous.",
  'label.your_experience': 'Votre expérience',
  'label.your_qualification': 'Vos qualifications',
  'notifications.waiting_for_assessor_approval': "En attente de l'approbation de l'évaluateur",
  'button.resend_assessment_request': "Renvoyer la demande d'évaluation",
  'errors.emails_must_be_different': 'Le courriel secondaire doit être différent de celui principal',
  'moduleTitle.company_details': 'Détails de la compagnie',
  'notifications.already_resent_assessment_request': "Vous avez déjà renvoyé la demande d'évaluation",
  'route.assessor_dashboard': "Tableau de bord de l'évaluateur",
  'pageTitle.register_assessor': 'Évaluateurs inscrits',
  'wizard.assessor_details': "Détails de l'évaluateur",
  'wizard.assessor_experience': "Expérience de l'évaluateur",
  'wizard.personal_details': 'Informations personnelles',
  'button.sign_off': 'Déconnecter',
  'button.sign_off_dashed': 'Déconnecter',
  'moduleTitle.sign_off': 'Déconnecter',
  'label.certify_participant_met_reqs': "Je certifie en tant qu'évaluateur pour l'activité que le participant a rencontré toutes les exigences.",
  'label.assessor_report': "Rapport de l'évaluateur",
  'label.content_update': 'Veuillez patienter. Le contenu se met à jour...',
  'label.comment_on_participant_improvement': "Veuillez commenter sur l'amélioration/performance du participant",
  'note.edit_participant_review': 'Pour corriger toute information, veuillez cliquer sur le bouton modifier',
  'errors.min_age': "L'âge minimale est {age}",
  'notifications.assessor_link_expired': "Le lien pour l'adhésion de l'évaluateur est expiré.",
  'label.secondary_email': 'Courriel secondaire',
  'moduleTitle.review_participant_info': 'Réviser les informations du participant',
  'label.loading_payment_gateway': 'Chargement de la passerelle de paiement',
  'label.consent_given_login_as_child': 'Le consentement a déjà été donné. Veuillez vous connecter en tant que votre enfant.',
  'notifications.only_one_qualification_journey_per_award': "Seulement un voyage d'aventure de qualification peut être configurer pour le Prix",
  'label.registration_fees_participant': "Paiement des frais d'adhésion - {name}(#{id})",
  'moduleTitle.leader_details': 'Informations sur le chef de groupe',
  'label.leader_name': 'Nom du chef de groupe',
  'label.leader_phone': 'Téléphone du chef de groupe',
  'label.leader_email': 'Courriel du chef de groupe',
  'moduleTitle.au_details': 'Informations sur le groupe',
  'label.au_name': 'Nom du groupe',
  'label.assessor_guidelines': 'Lignes directrices',
  'label.assessor_cond_req': 'Conditions et exigences',
  'label.assessor_ref_handbook': 'Référence au guide du Prix',
  'label.assessor_ref_online_modules': 'Référence au module de formation en ligne',
  'label.participant_has_no_aj_report': "Le participant n'a pas encore soumis son rapport",
  'moduleTitle.participant_details': 'Informations sur le participant',
  'label.participants_has_no_logs': "Le participant n'a aucune entrée pour le moment",
  'label.location_type': "Type d'endroit",
  'label.activity_ready_for_signoff': "Cette activité est prête pour l'approbation",
  'label.activities': 'Activités',
  'label.choose_how_you_want_to_login': 'Veuillez choisir votre moyen de connexion',
  'roles.leader': 'Chef de groupe',
  'roles.award_verifier': 'Vérificateur du Prix',
  'roles.coordinator': 'Coordonateur',
  'roles.aj_assessor': "Évaluateur du voyage d'aventure",
  'roles.aj_supervisor': "Superviseur du voyage d'aventure",
  'roles.instructor': 'Instructeur',
  'roles.nao_staff': "Personnel de l'entité national responsable du Prix",
  'roles.super_user': 'Utilisateur suprême',
  'roles.user': 'Utilisateur',
  'roles.viewer': 'Observateur',
  'roles.authorizing_contact': 'Contact autorisé',
  'roles.if_staff_superuser': 'Utilisateur suprême de la Fondation',
  'roles.if_staff_statistical_user': 'Utilisateur statistique de la Fondation',
  'roles.if_staff_viewer': 'Observateur de la Fondation.',
  'roles.aj_instructor': "Instructeur de voyage d'aventure",
  'label.if_you_have_questions_au': 'Si vous avez des questions concernant votre adhésion, veuillez communiquer avec votre groupe.',
  'label.we_will_send_you_an_email_leader': 'Nous vous enverrons un courriel lorsque votre compte CVP sera approuvé.',
  'moduleTitle.rejecting_assessor_invitation': "Rejeter l'invitation à devenir évaluateur",
  'notifications.assessor_invitation_rejected': "L'invitation pour devenir chef de groupe a été refusé.",
  'moduleTitle.participants_list_is_empty': 'La liste des participants est vide',
  'label.note_from_participant': 'Commentaires du participant',
  'label.you_can_send_aj_to_leader': "Vous pouvez soumettre votre voyage d'aventure à votre chef de groupe pour approbation.",
  'button.save_report': 'Enregistrer le rapport',
  'label.this_activity_has_no_assessor': "Cette activité n'a pas d'évaluateur. Vous devez indiquer les informations de votre évaluateur avant de la soumettre.",
  'label.activity_rejected_click_by_assessor': 'Votre activité a été rejeté par votre évaluateur. Cliquez ici pour',
  'button.reject': 'Refuser',
  'button.reject_invitation': "Refuser l'invitation",
  'label.reason': 'Raison',
  'label.accept_invitation_and_continue': "Accepter l'invitation et continuer",
  'pageTitle.registration_reject': "Refuser l'adhésion",
  'errors.you_must_be_older_than_register_for_leader': 'Vous devez être âgé de plus de {years} ans et  {months} mois afin de vous inscrire comme chef de groupe',
  'label.your_report_approve_now_send_to_leader_without_note': 'Votre rapport a été approuvé! Vous pouvez maintenant le soumettre à votre chef de groupe pour approbation',
  'button.stop_assessing_this_activity': "Arrêter d'évaluer cette activité.",
  'button.confirm': 'Confirmer',
  'moduleTitle.are_you_sure': 'êtes-vous sûr?',
  'label.content_restore': 'Restorer le contenu',
  'button.stop_editing': 'Arrêter la modification',
  'notifications.activity_has_been_rejected': "L'activité a été refusée",
  'notifications.aj_has_been_rejected': "Le voyage d'aventure a été refusé",
  'notifications.rp_has_been_rejected': 'Le projet de résidence a été refusé',
  'moduleTitle.additional_files': 'Fichiers supplémentaires',
  'moduleTitle.no_additional_files': 'Fichiers supplémentaires',
  'moduleTitle.stop_assessing_section': "Arrêter d'évaluer ce volet",
  'label.show_security_and_refund_policy': 'Voir la politique de remboursement et de sécurité',
  'moduleTitle.security_and_refund_policy': 'Politique de remboursement et de sécurité',
  'label.fees_payment': 'Frais des paiements',
  'label.redund_policy': 'Politique des remboursements',
  'label.security_policy': 'Politique de la sécurité',
  'label.leave_blank': 'Laisser libre',
  'label.frequently_asked_questions': 'Questions fréquemment posées',
  'label.language_selection_is_disabled_for_iac': 'La sélection de la langue est désactivée pour les centres ouvert du Prix',
  'errors.min_nights_required': 'Un minimum de {nights} nuit(s) est requis',
  'label.completion_date': 'Date de fin',
  'label.you_are_offline': 'Vous êtes hors ligne. Les changements effectués pourraient ne pas être sauvegardés',
  'errors.start_date_after_award_start': 'La date de début ne peut être avant le début de ce niveau.',
  'label.participants': 'Participants',
  'label.marketing_from_iaf': 'Accepter de recevoir du matériel promotionnel de la Fondation International',
  'label.marketing_from_oa': "Accepter de recevoir du matériel promotionnel de l'entité responsable du Prix.",
  'label.marketing_from_nao': "Accepter de recevoir du matériel promotionnel de l'entité nationale responsable du Prix.",
  'label.select_iac': 'Choisir le centre public du Prix.',
  'label.you_will_be_redirected_to_the_paypal_payment': 'Cliquez sur le button Payer ci-dessus pour effectuer votre paiement avec Visa, MasterCard, Visa débit ou PayPal.',
  'notifications.report_has_been_sent': 'Le rapport a été soumis.',
  'label.processing_paypal_payment': 'Traitement du paiement PayPal',
  'label.loading_paypal_gateway': 'Chargement du portail PayPal',
  'label.payment_failed': 'Le paiement a échoué',
  'label.payment_has_been_cancelled': 'Le paiement a été annulé ou a échoué',
  'roles.naa_oa_staff': "Personnel de l'entité nationale responsable du Prix.",
  'label.download_report_and_upload_signed_version': 'Télécharger le rapport et téléverser la version signée.',
  'button.download_summary_for_assessor': "Télécharger le sommaire pour l'évaluateur.",
  'label.pay_online_mastercard': 'Payer en ligne',
  'label.pay_online_paypal': 'Payer en ligne',
  'notifications.authorization_code_is_missing': "Le code d'autorisation est manquant",
  'errors.unknown_payment_error': 'Une erreur est survenue lors du paiement',
  'errors.already_in_use_by_auth_contact': 'Ce courriel est déjà utilisé par le contact autorisé',
  'roles.if_staff_stat_user': 'Utilisateur statistique FI',
  'moduleTitle.you_have_been_logged_out_due_to_inactivity': 'Vous avez été déconnecté puisque vous étiez inactif',
  'announcement.survey_description.do_think_people_are_lazy': "Pensez-vous que les jeunes sont lâches ou sont acquis? Si vous êtes un jeune ou un adulte, veuillez remplir notre sondage concernant votre pensée sur les jeunes d'aujourd'hui.",
  'announcement.survey_title.join_our_global_survey': 'Participez à notre sondage international',
  'announcement.survey_button.if_below_25': 'Si vous êtes âgés entre 16-25 ans',
  'announcement.survey_button.if_over_25': 'Si vous êtes âgés de plus de 25 ans',
  'moduleTitle.privacy_and_cookie_policy': 'Politique sur la vie privée et des témoins (cookies)',
  'label.we_have_made_some_important_changes': 'Nous avons apporté des changements importants à notre politique sur la vie privée et les témoins (cookies) et nous voulons vous informer en quoi cela vous implique vous et vos données.',
  'button.i_agree': "J'accepte",
  'button.see_more_details': "Voir plus d'information",
  'label.the_cookie_settings_on_this': '',
  'label.after_your_rp_describe': 'Décrivez vos observations pour votre projet de résidence en quelques mots.',
  'label.you_are_going_to_be_logged_out': 'Vous avez été déconnecté puisque vous étiez inactif.'
}
